import { Button, Tooltip } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { ExportIcon } from '@enterprise-ui/icons'

const ExportVisibleColumns = ({ onExportSelectedItems, isLoading = false }) => {
  return (
    <Tooltip content="Export visible columns" location="top">
      <Button
        type="ghost"
        onClick={onExportSelectedItems}
        className="button-bg-hover-transparent"
        aria-label="Export visible columns"
        isLoading={isLoading}
      >
        <EnterpriseIcon
          icon={ExportIcon}
          size="md"
          className="hc-clr-contrast-weak"
        />
      </Button>
    </Tooltip>
  )
}

export default ExportVisibleColumns
